import type { Vec2 } from './types'

let nextId = 0

export class Food {
  id: number
  pos: Vec2
  energy: number
  radius: number
  alive: boolean

  constructor(x: number, y: number, energy = 30) {
    this.id = nextId++
    this.pos = { x, y }
    this.energy = energy
    this.radius = 4
    this.alive = true
  }
}
